import { hasValue } from "@cak-legacy/core-utils";
import * as React from "react";

interface ObjectOverviewRendererProps {
  label: string;
  value: string;
  standalone?: boolean;
  flexDirection?: "row" | "column" | null | undefined;
  testid?: string;
}

export const ObjectOverviewRenderer: React.FC<React.PropsWithChildren<ObjectOverviewRendererProps>> = (props) => {
  const readItemClassName = hasValue(props.flexDirection)
    ? `read_item flexdirection-${props.flexDirection} full-width object-overview-renderer`
    : "read_item flexdirection-column full-width object-overview-renderer";

  const labelClassName = props.standalone
    ? "read-item__label read-item__label--standalone"
    : "read-item__label";

  return (
    <div data-testid={props.testid} className={readItemClassName}>
      <div className={labelClassName}>{props.label}</div>
      <div className="read-item__value">
        <div className="overview-edit-link">
          <span>{props.value ?? "-"}</span>
          {props.children}
        </div>
      </div>
    </div>
  );
};
